import { KpiScope } from './kpi-scope'
import { KpiScopeQuery } from './kpi-scope-query'
import { KpiScopeMutation } from './kpi-scope-mutation'

export const entities = [KpiScope]
export const resolvers = [KpiScopeQuery, KpiScopeMutation]

export * from './kpi-scope'
export * from './kpi-scope-query'
export * from './kpi-scope-mutation'
export * from './kpi-scope-type'
